import { Container, Divider, Stack, Title } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { TrustRuleApplicationsSection } from "../features/trustRules/TrustRuleApplicationsSection";
import { TrustRulesSection } from "../features/trustRules/TrustRulesSection";

// Страница «Настройки → Trust Rules». Тонкий контейнер,
// композирует секцию управления правилами и read-only историю
// применений — как `SettingsConnectionsPage`.
export function SettingsTrustRulesPage(): ReactElement {
  const { t } = useTranslation();
  return (
    <Container py="xl">
      <Stack gap="xl">
        <Title order={1}>{t("trustRules.pageTitle")}</Title>
        <TrustRulesSection />
        <Divider />
        <TrustRuleApplicationsSection />
      </Stack>
    </Container>
  );
}
